module.exports = __webpack_public_path__ + "static/media/facebook.d7cba517.svg";